
import { Component, Emit, Prop, Ref, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import moment from 'moment'
import { EnumPlaybackStatus } from '@xt/client'

import ClasshourLive from './Live.vue'
import ClasshourHomework from './Homework.vue'
import ClasshourWenfang from './Wenfang.vue'
import ClasshourMaterial from './Material.vue'
import MaterialLinkPop from './MaterialLinkPop.vue'

import type { ClasshourDetail as TClasshourDetail, ClasshourMemberHomework } from '@xt/client/entities/course-v2/types.d'

type ToggleSlideParams =
  | {
      type: 'homework-content'
      // 用户点击的作业id
      id: number
    }
  | {
      type: 'homework-submit'
    }

@Observer
@Component({
  components: {
    ClasshourLive,
    ClasshourHomework,
    ClasshourWenfang,
    ClasshourMaterial,
    MaterialLinkPop
  }
})
export default class DetailMain extends Vue {
  @Prop({ required: true }) classhourDetail: TClasshourDetail

  @Ref()
  materialLinkPop: {
    open: (link: string) => void
    hide: () => void
  }

  get showDownload() {
    return this.classhourDetail.classhourInfo.materialsStorageUrl !== null
  }

  get EnumPlaybackStatus() {
    return EnumPlaybackStatus
  }

  get liveStartTime() {
    return moment(this.classhourDetail.classhourInfo.startTime).format('YYYY-MM-DD HH:mm')
  }

  get isPlayback() {
    return this.classhourDetail.classhourInfo.playbackStatus === EnumPlaybackStatus.Playback
  }

  handleOpenPop() {
    this.materialLinkPop.open(this.classhourDetail.classhourInfo.materialsStorageUrl!)
  }

  handleClickHomeworkItem(id: number) {
    this.$emit('toggle-next', { type: 'homework-content', id } satisfies ToggleSlideParams)
  }

  handleClickHomeworkTitle(id: number) {
    this.$emit('toggle-next', { type: 'homework-submit', taskId: id })
  }
}
